import React from "react";

import { usePendSearchQuery } from "queries";

import { pendResultItem } from "../resultItems";

import { ReactComponent as PendsIcon } from "static/images/pends_search.svg";

const pendSection = () => {
	return {
		name: "pends",
		title: "Pends",
		useSearchQuery: usePendSearchQuery,
		renderItem: pendResultItem,
		getIcon: () => <PendsIcon />,
		getLink: ({ applicationId, id }) =>
			`/applications/${applicationId}/pend/${id}`,
		requiredPermissions: [],
	};
};

export default pendSection;
